var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimalistArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5601 0.891433C10.8042 0.647355 11.1999 0.647355 11.444 0.891433C11.6881 1.13551 11.6881 1.53124 11.444 1.77532L6.44402 6.77532C6.19994 7.01939 5.80421 7.01939 5.56013 6.77532L0.560132 1.77532C0.316054 1.53124 0.316054 1.13551 0.560132 0.891433C0.80421 0.647355 1.19994 0.647355 1.44402 0.891433L6.00207 5.44949L10.5601 0.891433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimalistArrow);
export default __webpack_public_path__ + "static/media/minimalist-arrow.bfdf1ca69f2d106ca71f162da29277d9.svg";
export { ForwardRef as ReactComponent };